import axios from 'axios';
import config from '../config/config';
import history from './../history';
import {
    SUPPORTER_LIST_RECEIVE_SUPPORTERS,
    SUPPORTER_LIST_PAGINATE,
    SUPPORTER_LIST_SEARCH_STRING_CHANGE,
    SUPPORTER_LIST_PERIODS_FILTER_CHANGE,
    SUPPORTER_LIST_STATES_FILTER_CHANGE,
    SUPPORTER_LIST_DIALOG_ADD_SUPPORTER,
    SUPPORTER_LIST_CANCEL_ADD_SUPPORTER,
    SUPPORTER_LIST_SEND_ADD_SUPPORTER,
    SUPPORTER_LIST_RECEIVE_ADD_SUPPORTER,
    SUPPORTER_LIST_RECEIVE_ADD_SUPPORTER_ERROR
} from '../config/actions';

export function getSupporters() {
    return dispatch => {
        axios(config.server.endpoint + 'backend/supporter', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch(receiveSupporters(response.data));
            }
        })
    }
}

export function receiveSupporters(data) {
    return {
        type: SUPPORTER_LIST_RECEIVE_SUPPORTERS,
        data
    }
}

export function paginate(offset) {
    return {
        type: SUPPORTER_LIST_PAGINATE,
        offset
    }
}

export function searchStringChange(searchString) {
    return {
        type: SUPPORTER_LIST_SEARCH_STRING_CHANGE,
        searchString
    }
}

export function periodsFilterChange(periodsFilter) {
    return {
        type: SUPPORTER_LIST_PERIODS_FILTER_CHANGE,
        periodsFilter
    }
}

export function statesFilterChange(statesFilter) {
    return {
        type: SUPPORTER_LIST_STATES_FILTER_CHANGE,
        statesFilter
    }
}